import React from "react"
import { NavLink } from "react-router-dom"
import Header4 from "../Common/Header4"
import Footer from "../Common/Footer"
import Banner from "../Elements/Banner"
import Projects6 from "../Elements/Projects6"
import ReactPlayer from "react-player"

var bnrimg = require("./../../images/projects/portrait/Jeddah2/bg.png")

class Jeddah2 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="Villa · Jeddah · KSA"
            pagename="Jeddah Villa"
            description="Transforming this villa in Jeddah into a modern luxury residence—where contemporary architecture, clean lines, and carefully curated finishes come together to create a refined living environment defined by comfort, elegance, and understated sophistication."
            bgimage={bnrimg}
          />

          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 inner-page-padding stick_in_parent">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-7  sticky_column">
                  <div className="project-detail-containt">
                    <div className="bg-white text-black">
                      <h3>
                        A modern luxury design vision that elevates everyday
                        living
                      </h3>

                      <p>
                        In this Jeddah villa, design is guided by modern
                        clarity, balance, and refined simplicity. Clean
                        architectural lines, a sophisticated material palette,
                        and carefully curated finishes shape interiors that feel
                        open, elegant, and effortlessly luxurious. Every element
                        is intentionally composed to enhance comfort, spatial
                        flow, and a contemporary sense of refinement.
                      </p>

                      <p>
                        The villa is thoughtfully planned to accommodate modern
                        living, featuring spacious bedrooms including a refined
                        master suite, a contemporary kitchen designed for both
                        daily use and hosting, well-appointed bathrooms, and
                        generous living and reception areas connected through
                        seamless circulation. Each space is crafted to balance
                        openness and privacy—resulting in a home that reflects
                        individuality, prestige, and modern luxury living in
                        Jeddah.
                      </p>

                      <div className="product-block">
                        <ul>
                          <li>
                            <h4 className="m-b10">Status</h4>
                            <p>Completed</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Client</h4>
                            <p>Property Owner</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Project type</h4>
                            <p>Modern Luxury Villa</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Scope of work</h4>
                            <p>Design and build</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Location</h4>
                            <p>Jeddah, KSA</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Year</h4>
                            <p>2022</p>
                          </li>
                        </ul>
                      </div>
                      <div className="m-b0">
                        <div className="sx-divider divider-1px  bg-black">
                          <i className="icon-dot c-square" />
                        </div>
                      </div>
                      {/* <ul className="social-icons social-square social-darkest m-b0">
                                            <li><a href="https://www.facebook.com" target="_blank" className="fa fa-facebook" /></li>
                                                <li><a href="https://twitter.com" target="_blank" className="fa fa-twitter" /></li>
                                                <li><a href="https://in.linkedin.com" target="_blank" className="fa fa-linkedin" /></li>
                                                <li><a href="https://rss.com" target="_blank" className="fa fa-rss" /></li>
                                                <li><a href="https://www.youtube.com" target="_blank" className="fa fa-youtube" /></li>
                                                <li><a href="https://www.instagram.com/innen_interiors/" target="_blank" className="fa fa-instagram" /></li>
                                            </ul> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 ">
                  <div className="project-detail-outer">
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/1.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/2.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/3.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/4.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/5.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/6.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/7.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/8.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/9.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/10.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/11.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/12.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/13.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/14.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/15.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/16.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/17.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/18.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/19.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/20.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/21.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/22.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/23.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/24.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/25.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/26.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/27.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/28.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/29.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/31.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/32.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/33.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/34.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/35.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/36.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/37.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/38.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/39.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/40.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/41.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/42.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/43.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/44.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/45.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/46.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/47.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/48.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/49.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/50.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/51.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/52.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/53.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/54.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/55.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/56.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/57.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/58.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/59.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/60.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/61.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/62.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/63.jpg")}
                          alt=""
                        />
                      </div>
                    </div>{" "}
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/64.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Jeddah2/65.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    {/* <div className="sx-box">
                                            <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                                                <img src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg" alt="" />
                                                <NavLink to={"#"} className="play-now" data-toggle="modal" data-target="#myModal5">
                                                    <i className="icon fa fa-play" />
                                                    <span className="ripple" />
                                                </NavLink>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
              <div className="project-detail-containt-2 m-t50">
                <h3>
                  Creating a modern luxury villa defined by balance, refined
                  detailing, and contemporary comfort
                </h3>

                <p className="m-b0">
                  Modern luxury design is guided by clarity and intention rather
                  than excess. Clean architectural lines, balanced proportions,
                  and carefully curated materials shape an atmosphere of
                  understated elegance—where comfort and sophistication coexist
                  effortlessly. Through thoughtful planning and precise
                  detailing, the villa is transformed into a refined residence
                  designed to support contemporary living with calm, confidence,
                  and lasting appeal.
                </p>
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END  */}
          {/* <Projects6 /> */}
        </div>

        <div className="modal fade" id="myModal5" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <ReactPlayer url="https://www.youtube.com/watch?v=Oy2QIiSQT2U" />
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default Jeddah2
